import { toast } from 'react-toastify';

export const ErrorNotification = (msg: string) => {
  const toastId = 'error-alert';
  if (toast.isActive(toastId)) {
    toast.update(toastId, {
      render: msg,
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  } else {
    toast.error(msg, {
      toastId,
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  }
};
